<template>
  <div
    class="min-h-screen w-full bg-cover bg-center"
    :style="containerStyle"
  >
    <div
      v-if="updateExists"
      class="text-blue-800 p-4 bg-blue-200 absolute top-0 inset-x-0 font-bold"
    >
      An update is available
      <button
        type="button"
        @click="refreshApp"
      >
        Update
      </button>
    </div>

    <transition
      enter-active-class="transition-all"
      leave-active-class="absolute transition-all"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <pending-submission
        :show-submitted="pendingSurveySubmit"
        @close="closePendingSurveySubmit"
      />
    </transition>
    <main class="max-w-5xl mx-auto min-h-screen">
      <transition
        enter-active-class="transition-all"
        leave-active-class="absolute transition-all"
        enter-class="opacity-0 scale-100"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-70"
      >
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Update from './mixins/update'
import PendingSubmission from './components/PendingSubmission'

export default {
  components: {
    PendingSubmission
  },
  mixins: [Update],
  computed: {
    ...mapGetters([
      'pendingSurveySubmit'
    ]),
    containerStyle () {
      /*
      Show background image for pages outside the survey...
       */
      let backgroundRoutes = ['home', 'thank-you', 'pending']

      if (backgroundRoutes.indexOf(this.$route.name) === -1) {
        return ''
      }

      return {
        backgroundImage: 'url("/img/bg.jpg")'
      }
    }
  },
  methods: {
    closePendingSurveySubmit () {
      console.log('closePendingSurveySubmit')
      this.$store.commit('PENDING_SURVEY_SUBMITTED_UPDATED', false)
    }
  }
}
</script>
